import {
  AppstoreOutlined,
  CalendarOutlined,
  CopyrightOutlined,
  EyeOutlined,
  FileSearchOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  SearchOutlined,
  TableOutlined,
} from "@ant-design/icons";
import {
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Empty,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import Meta from "antd/lib/card/Meta";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import Highlighter from "react-highlight-words";
import { useHistory } from "react-router-dom";
import { openNotification } from "../../../../components/Notification";
import { UserContext } from "../../../../contexts/UserContext";
import { useWidth } from "../../../../hooks";
import { useQuery } from "../../../../hooks/useQuery";
import { encaminhamentoService } from "../../../../services/resources/encaminhamentoService";
import { enderecoService } from "../../../../services/resources/enderecoService";
import {
  ENCAMINHAMENTOS_TAG_FILTER,
  isEmpty,
  OPCOES_TAMANHO_PAGINA,
  removeByProp,
  removeEmpty,
  STATUS_COLORS,
  TipoRegistro,
  urls,
  USER_ROLES,
} from "../../../../utils";
import { labelTags } from "../../../../utils/dicionario";

const { Option } = Select;

export const TabelaEncaminhamentos = ({ recebidos, enviados }) => {
  const [form] = Form.useForm();
  const formAvancado = form;
  const { width } = useWidth();
  const history = useHistory();
  const query = useQuery();
  const { user, status } = useContext(UserContext);

  const [isTableView, setIsTableView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  const [encaminhamentos, setEncaminhamentos] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [bairros, setBairros] = useState([]);

  const [filter, setFilter] = useState({
    ativo: true,
    page: 0,
    size: OPCOES_TAMANHO_PAGINA[0],
    ...(recebidos && {
      codigoInstituicaoDestinataria: user.codigo_instituicao,
    }),
    ...(enviados && {
      codigoInstituicaoRemetente: enviados && user.codigo_instituicao,
    }),
  });

  const [paginacao, setPaginacao] = useState({
    currentPage: 0,
    totalElements: 0,
    size: OPCOES_TAMANHO_PAGINA[0],
  });

  const columns = [
    {
      title: <strong>status</strong>,
      dataIndex: "statusDescricao",
      key: "status",
      render: (status) => (
        <Badge
          style={{
            backgroundColor: STATUS_COLORS[status],
            color: "#333333",
            fontWeight: "bold",
          }}
          count={status}
        />
      ),
    },
    {
      title: <strong>protocolo</strong>,
      dataIndex: "denunciaIdentificadorExterno",
      key: "protocolo",
      render: (text) => (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ff9945",
            padding: 0,
            color: "#fff",
          }}
          searchWords={[filter?.identificadorExterno]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ),
    },
    {
      title: <strong>{recebidos ? "remetente" : "destinatário"}</strong>,
      dataIndex: recebidos
        ? "instituicaoRemetenteNome"
        : "instituicaoDestinatariaNome",
      key: "instituicao",
    },
    {
      title: <strong>cidade</strong>,
      dataIndex: "denunciaMunicipio",
      key: "denunciaMunicipio",
      render: (text) => (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ff9945",
            padding: 0,
            color: "#fff",
          }}
          searchWords={[filter?.denunciaMunicipio]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ),
    },
    {
      title: <strong>início</strong>,
      dataIndex: "dataInicio",
      key: "dataInicio",
      render: (text) => (text ? moment(text).format("DD/MM/yyyy") : ""),
    },
    {
      title: <strong>prazo</strong>,
      dataIndex: "dataPrevistaConclusao",
      key: "prazo",
      render: (text) =>
        text ? (
          moment(text).isAfter(moment()) ? (
            `${moment(text).format("DD/MM/yyyy")}`
          ) : (
            <Typography.Text strong type="danger">
              {moment(text).format("DD/MM/yyyy")}
            </Typography.Text>
          )
        ) : (
          <Typography.Text strong>indefinido</Typography.Text>
        ),
    },
    {
      title: <strong>tipo registro</strong>,
      dataIndex: ["denuncia", "tipoRegistro"],
      key: "tipoRegistro",
      sorter: {
        multiple: 1,
      },
    },
    {
      title: <strong>ações</strong>,
      key: "action",
      width: "1rem",
      // MODIFICAÇÃO: Lógica de navegação dinâmica para as ações da tabela
      render: (record) => {
        const {
          denunciaCodigo,
          denunciaIdentificadorExterno,
          codigo,
          denuncia,
        } = record;
        const isAtendimento = denuncia?.tipoRegistro === "ATENDIMENTO";
        const origem = isAtendimento ? "atendimento" : "denuncia";

        return (
          <Space
            size="small"
            style={{ display: "flex", justifyContent: "end" }}
          >
            {user?.authorities?.includes(
              USER_ROLES.CONSULTAR_ENCAMINHAMENTOS_INSTITUICAO
            ) && (
              <Button
                className="action-button"
                type="primary"
                ghost
                onClick={(event) => {
                  event.stopPropagation();
                  history.push({
                    pathname: urls.ENCAMINHAMENTO_DETAILS.replace(
                      ":codigo",
                      codigo
                    ),
                    state: { origem: origem },
                  });
                }}
                title={`Visualizar encaminhamento de ${denunciaIdentificadorExterno}`}
              >
                <EyeOutlined style={{ fontSize: "1.2rem" }} />
              </Button>
            )}
            {user?.authorities?.includes(
              USER_ROLES.CONSULTAR_DETALHE_DENUNCIA
            ) && (
              <Button
                className="action-button"
                type="primary"
                onClick={(event) => {
                  event.stopPropagation();
                  const targetUrl = isAtendimento
                    ? urls.ATENDIMENTO_DETAILS.replace(
                        ":codigo",
                        denunciaCodigo
                      )
                    : urls.DENUNCIA_DETAILS.replace(":codigo", denunciaCodigo);
                  history.push(targetUrl);
                }}
                title={`Visualizar ${origem} ${denunciaIdentificadorExterno}`}
              >
                <FileSearchOutlined style={{ fontSize: "1.2rem" }} />
              </Button>
            )}
          </Space>
        );
      },
    },
  ];

  const getAllEncaminhamentos = async (params) => {
    setLoading(true);
    try {
      const response = await encaminhamentoService.getAllEncaminhamentos(
        removeEmpty(params)
      );
      const { content } = response.data;
      setEncaminhamentos(content);
      setPaginacao({
        currentPage: response?.data?.currentPage,
        totalElements: response?.data?.totalElements,
        size: response?.data?.size,
      });
    } catch (reason) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao buscar os encaminhamentos!</strong>,
        reason?.response?.data?.detail
      );
    } finally {
      setLoading(false);
    }
  };

  async function getCidades(estado) {
    try {
      const response = await enderecoService.getCitysState(estado);
      setCidades(response.data);
    } catch (reason) {
      openNotification(
        "error",
        <strong>Ocorreu um erro ao carregar as cidades!</strong>,
        "Erro: " + reason?.response?.data?.userMessage
      );
    }
  }

  async function getDistricts(city_id) {
    if (city_id) {
      try {
        const response = await enderecoService.getDistrictsCitys(city_id);
        setBairros(response.data);
      } catch (reason) {
        openNotification(
          "error",
          <strong>Ocorreu um erro ao carregar os bairros!</strong>,
          "" + reason
        );
      }
    }
  }

  function onFilter(filters) {
    if (filters?.statusList?.includes("EM ANDAMENTO")) {
      filters.statusList.push("A VALIDAR");
    }
    setFilter({
      ...filter,
      ...filters,
      page: 0,
    });
  }

  function convertValuesTags(value) {
    const valueCidade = cidades.find((item) => item.id === value)?.nome;
    if (valueCidade) return valueCidade?.toUpperCase();
    return value;
  }

  function convertLabelsTags(label) {
    return labelTags[label];
  }

  function clearAll() {
    const newFilter = {
      ativo: true,
      page: 0,
      size: paginacao.size,
      ...(recebidos && {
        codigoInstituicaoDestinataria: user.codigo_instituicao,
      }),
      ...(enviados && {
        codigoInstituicaoRemetente: user.codigo_instituicao,
      }),
    };
    setFilter(newFilter);
    form.resetFields();
    formAvancado.resetFields();
    history.push(
      recebidos ? urls.ENCAMINHAMENTOS_RECEBIDOS : urls.ENCAMINHAMENTOS_ENVIADOS
    );
  }

  const tagsNotShow = [
    "ativo",
    "page",
    "size",
    "sort",
    "codigoInstituicaoDestinataria",
    "codigoInstituicaoRemetente",
  ];

  useEffect(() => {
    const queries = query.getAll("status");
    getDistricts(filter.cidadeIdList);
    getCidades(1);
    const finalFilter = { ...filter };
    if (queries.length > 0 && !filter.statusList) {
      formAvancado.setFieldsValue({ statusList: queries });
      finalFilter.statusList = queries;
    }
    getAllEncaminhamentos(finalFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  useEffect(() => {
    if (width <= 768) {
      setIsTableView(false);
    }
    // eslint-disable-next-line
  }, [width]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col>
          <Form
            name="encaminhamento_filtro"
            layout="inline"
            form={form}
            onValuesChange={({ identificadorExterno }) =>
              onFilter({ identificadorExterno })
            }
          >
            <Form.Item name="identificadorExterno">
              <Input
                prefix={<SearchOutlined />}
                placeholder="Busque pelo protocolo"
                allowClear
              />
            </Form.Item>
          </Form>
        </Col>
        <Col>
          <Button type="primary" onClick={() => setShowFilters(true)}>
            Filtros Avançados <FilterOutlined />
          </Button>
        </Col>
        <Col>
          <Button onClick={clearAll}>Limpar Filtros</Button>
        </Col>
        {width > 768 && (
          <Col>
            <Radio.Group
              defaultValue={isTableView}
              onChange={({ target: { value } }) => setIsTableView(value)}
            >
              <Radio.Button value={true}>
                <TableOutlined />
              </Radio.Button>
              <Radio.Button value={false}>
                <AppstoreOutlined />
              </Radio.Button>
            </Radio.Group>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={24}>
          {Object.entries(removeEmpty(filter))
            .filter(([label]) => !tagsNotShow.includes(label))
            .map(([label, value]) => (
              <Tag
                color="var(--border-color)"
                closable
                key={label + value}
                onClose={() => {
                  onFilter(removeByProp(filter, label));
                  form.setFieldsValue({ [label]: null });
                  formAvancado.setFieldsValue({ [label]: null });
                }}
              >
                {(
                  ENCAMINHAMENTOS_TAG_FILTER[label] || convertLabelsTags(label)
                )?.toUpperCase() +
                  ": " +
                  convertValuesTags(value, label)}
              </Tag>
            ))}
        </Col>
      </Row>
      <Col span={24}>
        {isTableView ? (
          <Table
            loading={loading}
            dataSource={encaminhamentos}
            columns={encaminhamentos?.length ? columns : []}
            pagination={false}
            size="small"
            rowKey="codigo"
            locale={{
              emptyText: <Empty description={<h2>Sem encaminhamentos</h2>} />,
            }}
          />
        ) : (
          <Row gutter={[16, 16]} justify="start">
            {encaminhamentos.map((encaminhamento) => {
              const isAtendimentoCard =
                encaminhamento.denuncia?.tipoRegistro === "ATENDIMENTO";
              const origemCard = isAtendimentoCard ? "atendimento" : "denuncia";
              return (
                <Col key={encaminhamento.codigo} xs={24} md={12} lg={8} xl={6}>
                  <Card
                    style={{ width: "100%", marginTop: 16 }}
                    hoverable
                    actions={[
                      <Space
                        key="actions"
                        style={{ width: "100%", justifyContent: "center" }}
                      >
                        {user?.authorities?.includes(
                          USER_ROLES.CONSULTAR_ENCAMINHAMENTOS_INSTITUICAO
                        ) && (
                          <Button
                            className="action-button"
                            type="primary"
                            ghost
                            icon={<EyeOutlined />}
                            onClick={(event) => {
                              event.stopPropagation();
                              history.push({
                                pathname: urls.ENCAMINHAMENTO_DETAILS.replace(
                                  ":codigo",
                                  encaminhamento.codigo
                                ),
                                state: { origem: origemCard },
                              });
                            }}
                            title={`Visualizar encaminhamento de ${encaminhamento.denunciaIdentificadorExterno}`}
                          />
                        )}
                        {user?.authorities?.includes(
                          USER_ROLES.CONSULTAR_DETALHE_DENUNCIA
                        ) && (
                          <Button
                            className="action-button"
                            type="primary"
                            icon={<FileSearchOutlined />}
                            onClick={(event) => {
                              event.stopPropagation();
                              const targetUrl = isAtendimentoCard
                                ? urls.ATENDIMENTO_DETAILS.replace(
                                    ":codigo",
                                    encaminhamento.denunciaCodigo
                                  )
                                : urls.DENUNCIA_DETAILS.replace(
                                    ":codigo",
                                    encaminhamento.denunciaCodigo
                                  );
                              history.push(targetUrl);
                            }}
                            title={`Visualizar ${origemCard} ${encaminhamento.denunciaIdentificadorExterno}`}
                          />
                        )}
                      </Space>,
                    ]}
                  >
                    <Skeleton loading={loading} avatar active>
                      <Meta
                        description={
                          <>
                            <Row justify="space-between">
                              <Col>
                                <p>
                                  <InfoCircleOutlined /> Protocolo:{" "}
                                  <strong>
                                    {
                                      encaminhamento.denunciaIdentificadorExterno
                                    }
                                  </strong>
                                </p>
                                <p>
                                  <CopyrightOutlined /> Canal:{" "}
                                  <strong>
                                    {encaminhamento.denunciaCanalSigla}
                                  </strong>
                                </p>
                              </Col>
                              <Badge
                                style={{
                                  backgroundColor:
                                    STATUS_COLORS[
                                      encaminhamento.statusDescricao
                                    ],
                                  color: "#333333",
                                  fontWeight: "bold",
                                }}
                                count={encaminhamento.statusDescricao}
                              />
                            </Row>
                            <Divider />
                            <Row justify="space-between" align="center">
                              <p>
                                <CalendarOutlined /> Ínicio:{" "}
                                {moment(encaminhamento.dataInicio).format(
                                  "DD/MM/yyyy"
                                )}
                              </p>
                              <p>
                                <CalendarOutlined /> Prazo:{" "}
                                {moment(
                                  encaminhamento.dataPrevistaConclusao
                                ).format("DD/MM/yyyy")}
                              </p>
                            </Row>
                          </>
                        }
                      />
                    </Skeleton>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}

        <Row justify="end">
          <Col style={{ marginTop: 20 }}>
            <Pagination
              size="small"
              showSizeChanger
              simple={width < 768}
              pageSizeOptions={OPCOES_TAMANHO_PAGINA}
              defaultPageSize={paginacao.size}
              total={paginacao.totalElements}
              showTotal={(total) => (
                <strong>{total} encaminhamentos no total</strong>
              )}
              onChange={(page, size) => {
                setFilter({
                  ...filter,
                  page: filter.size !== size ? 0 : page - 1,
                  size,
                });
              }}
              current={paginacao.currentPage + 1}
            />
          </Col>
        </Row>
      </Col>
      <Modal
        centered
        title="Filtros Avançados"
        visible={showFilters}
        onCancel={() => setShowFilters(false)}
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              setShowFilters(false);
              onFilter(formAvancado.getFieldsValue());
            }}
          >
            Aplicar Filtros
          </Button>,
        ]}
      >
        <Form name="denuncia_filtro" layout="vertical" form={formAvancado}>
          <Collapse ghost defaultActiveKey={["1"]}>
            <Collapse.Panel header="Dados Gerais" key="1">
              <Form.Item name="statusList" label="Status">
                <Select
                  placeholder="Escolha um ou mais status"
                  style={{ width: "100%" }}
                  mode="multiple"
                  options={status
                    ?.filter(
                      ({ descricao }) =>
                        descricao === "EM ABERTO" ||
                        descricao === "FINALIZADA" ||
                        descricao === "EM ANDAMENTO"
                    )
                    .map(({ descricao }) => ({
                      label: descricao,
                      value: descricao,
                    }))}
                  allowClear
                />
              </Form.Item>
              <Form.Item name="denunciaMunicipio" label="Município">
                <Select
                  placeholder="Escolher município"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={cidades?.map(({ nome }) => ({
                    label: nome,
                    value: nome,
                    key: nome,
                  }))}
                />
              </Form.Item>
              <Form.Item name="denunciaBairroNome" label="Bairro">
                <Input placeholder="Busque pelo nome do bairro" allowClear />
              </Form.Item>
              <Form.Item name="denunciaTipoRegistro" label="Tipo de Registro">
                <Select placeholder="Selecione o tipo de registro" allowClear>
                  {Object.keys(TipoRegistro).map((key) => (
                    <Option key={key} value={key}>
                      {TipoRegistro[key]}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Collapse.Panel>
          </Collapse>
        </Form>
      </Modal>
    </>
  );
};
